export { default as MobileAppBanner } from './MobileAppBanner';



// WEBPACK FOOTER //
// ./src/components/MobileAppBanner/index.ts